// DOCS-KB: a doc's kind as an icon (Docs rows, FAVORITES, ⌘K, link cards) and "edited 2h ago".
import {
  BookOpenIcon,
  FileTextIcon,
  ListChecksIcon,
  type LucideIcon,
  ScaleIcon,
} from "lucide-react";

const ICONS: Partial<Record<string, LucideIcon>> = {
  sop: ListChecksIcon,
  policy: ScaleIcon,
  kb: BookOpenIcon,
};

/** `ListChecks` SOP, `Scale` policy, `BookOpen` KB article, `FileText` any other page. */
export const docIcon = (kind: string): LucideIcon => ICONS[kind] ?? FileTextIcon;

/** The Docs filter a kind falls under: vision, journal, decision and strategy count as Pages. */
export type DocKindFilter = "sop" | "policy" | "kb" | "page";
export const docFilterOf = (kind: string): DocKindFilter =>
  kind === "sop" || kind === "policy" || kind === "kb" ? kind : "page";

/** "just now", "5m ago", "2h ago", "3d ago", then "12 Oct". */
export function ago(iso: string, now: Date = new Date()): string {
  const s = Math.max(0, Math.round((now.getTime() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86_400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 7 * 86_400) return `${Math.floor(s / 86_400)}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" });
}
